import { useEffect, useState } from "react"

import EventEmitter from "src/EventEmitter"

const useSurveyModal = () => {
  const [surveyOpen, setSurveyOpen] = useState(false)

  useEffect(() => {
    const onStudentSurvey = () => setSurveyOpen(true)
    EventEmitter.subscribe("student_survey", onStudentSurvey)

    return () => EventEmitter.unsubscribe("student_survey", onStudentSurvey)
  }, [])

  return { surveyOpen, setSurveyOpen }
}

export default useSurveyModal
